import { TypedDocumentNode, gql } from "@apollo/client";

export interface Categories {
  categories: {
    id: string;
    name: string;
    linkTitle: string;
    categoryType: {
      name: string;
      value: string;
    };
  }[];
}

export const GET_CATEGORIES: TypedDocumentNode<Categories> = gql`
  query GetCategories {
    categories {
      id
      name
      linkTitle
      categoryType {
        name
        value
      }
    }
  }
`;
